import { MODULE_PERMISSION_MAP } from "@miplatform/constants";
import { PlatformModules } from "@miplatform/types";

export const getModulesByAccessPermissions = (permissions: string[]) => {
  return Object.values(PlatformModules).filter((module) => {
    const modulePermissions = MODULE_PERMISSION_MAP[module];
    return modulePermissions
      ? permissions.includes(modulePermissions.access)
      : false;
  });
};

export const getPermissionNameType = (permissionName: string): string => {
  const parts = permissionName.split(":");
  return parts.length > 1 ? parts[parts.length - 1].trim() : permissionName;
};
